import LayersApi from './LayersApi.js'

function bitMapLayers(view) {
  const bitmaps = [
    {
      geotype: 'bitmap',
      id: 'mesasur',
      bounds: [-101.457426, 21.985513, -101.428263, 22.017685],
      //image: 'https://img-satellite.s3.amazonaws.com/satelite-images/mesa_morenos_sur.jpg',
      image: 'https://img-satellite.s3.amazonaws.com/mesa_morenos_sur.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'mesanor',
      bounds: [-101.458567, 22.021988, -101.432781, 22.062226],
      image: 'https://img-satellite.s3.amazonaws.com/mesa_morenos_norte.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'cuervos',
      bounds: [-102.2169, 21.740861, -102.167873, 21.781791],
      image: 'https://img-satellite.s3.amazonaws.com/los_cuervos.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'canada',
      bounds: [-102.205688, 22.011145, -102.19404, 22.019227],
      image: 'https://img-satellite.s3.amazonaws.com/canada_honda.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'cuyoaco',
      bounds: [-97.592939, 19.565127, -97.558305, 19.602642],
      image: 'https://img-satellite.s3.amazonaws.com/cuyoaco.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'palo',
      bounds: [-101.866287, 21.836795, -101.834034, 21.909276],
      image: 'https://img-satellite.s3.amazonaws.com/palo_alto.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'mesas',
      bounds: [-98.990668, 23.383034, -98.852426, 23.470828],
      image: 'https://img-satellite.s3.amazonaws.com/tres_mesas.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'mesaspaz',
      bounds: [-98.934334, 23.311336, -98.799376, 23.368168],
      image: 'https://img-satellite.s3.amazonaws.com/tres_mesas_la_paz.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'mxsolar1',
      bounds: [-100.567399, 21.053574, -100.548042, 21.062777],
      image: 'https://img-satellite.s3.amazonaws.com/mexsolar_1.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'mxsolar2',
      bounds: [-100.540262, 21.053445, -100.527891, 21.06187],
      image: 'https://img-satellite.s3.amazonaws.com/mexsolar_2.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'guajiro',
      bounds: [-99.735588, 20.17214, -99.713667, 20.18536],
      image: 'https://img-satellite.s3.amazonaws.com/guajiro.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'horus',
      bounds: [-102.336849, 22.086354, -102.307985, 22.107202],
      image: 'https://img-satellite.s3.amazonaws.com/horus_solar.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'magdalena',
      bounds: [-98.361022, 19.543842, -98.313029, 19.566538],
      image: 'https://img-satellite.s3.amazonaws.com/la_magdalena_2.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'xcala',
      bounds: [-98.581652, 19.603288, -98.565155, 19.632063],
      image: 'https://img-satellite.s3.amazonaws.com/nueva_xcala.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'xcalanor',
      bounds: [-98.602787, 19.634409, -98.566712, 19.659675],
      image: 'https://img-satellite.s3.amazonaws.com/nueva_xcala_norte.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'viborillas',
      bounds: [-101.730195, 21.821885, -101.711176, 21.843839],
      image: 'https://img-satellite.s3.amazonaws.com/viborillas.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'santiago',
      bounds: [-101.250238, 21.871462, -101.209321, 21.898807],
      image: 'https://img-satellite.s3.amazonaws.com/santiago.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'moctezuma',
      bounds: [-106.495345, 30.154516, -106.442322, 30.203639],
      image: 'https://img-satellite.s3.amazonaws.com/moctezuma.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'tepeyahualco',
      bounds: [-97.331001, 19.527485, -97.314589, 19.552739],
      image: 'https://img-satellite.s3.amazonaws.com/solar_tepeyahualco.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'salsipuedes',
      bounds: [-100.864655, 22.614658, -100.853383, 22.624383],
      image: 'https://img-satellite.s3.amazonaws.com/salsipuedes_solar.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'eolico-santiago',
      bounds: [-101.247924, 21.618655, -101.204843, 21.660844],
      image: 'https://img-satellite.s3.amazonaws.com/eolico_santiago.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'eolico-santiago-n',
      bounds: [-101.197538, 21.662144, -101.187868, 21.698785],
      image: 'https://img-satellite.s3.amazonaws.com/eolico_santiago_norte.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'eolico-santiago-n2',
      bounds: [-101.213771, 21.702059, -101.196056, 21.733071],
      image: 'https://img-satellite.s3.amazonaws.com/eolico_santiago_norte_2.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'helios-generacion',
      bounds: [-101.790704, 23.893904, -101.748194, 23.922387],
      image: 'https://img-satellite.s3.amazonaws.com/helios_generacion.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'eolico-dolores',
      bounds: [-98.642191, 25.471057, -98.577168, 25.590343],
      image: 'https://img-satellite.s3.amazonaws.com/eolico_dolores.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'pima-solar',
      bounds: [-112.753286, 30.781139, -112.724039, 30.799524],
      image: 'https://img-satellite.s3.amazonaws.com/pima_solar.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'trinidad-solar',
      bounds: [-104.481023, 24.216517, -104.463005, 24.239991],
      image: 'https://img-satellite.s3.amazonaws.com/trinidad_solar.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'solar-lucha',
      bounds: [-104.140761, 26.540838, -104.114818, 26.572132],
      image: 'https://img-satellite.s3.amazonaws.com/la_lucha.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'el-trece',
      bounds: [-104.460708, 28.628776, -104.449494, 28.637058],
      image: 'https://img-satellite.s3.amazonaws.com/el_trece.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'solar-don-diego',
      bounds: [-111.094891, 30.140479, -111.082086, 30.172461],
      image: 'https://img-satellite.s3.amazonaws.com/don_diego.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'pierIV',
      bounds: [-97.411266, 18.672959, -97.346623, 18.73158],
      image: 'https://img-satellite.s3.amazonaws.com/pier_4.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'loma-col',
      bounds: [-73.647583, 9.591364, -73.62819, 9.614033],
      image: 'https://img-satellite.s3.amazonaws.com/solar_la_loma_col.jpg',
      visible: view,
    },
    {
      geotype: 'bitmap',
      id: 'sub-la-loma-col',
      bounds: [-73.619327, 9.598791, -73.616481, 9.60282],
      image: 'https://img-satellite.s3.amazonaws.com/sub_la_loma_col.jpg',
      visible: view,
    },
    // {
    //   geotype: 'bitmap',
    //   id: 'centro',
    //   bounds: [-117.1250428,14.1535775, -86.5981709,33.2019969],
    //   image: 'https://img-satellite.s3.amazonaws.com/flood-zones-layer/flood_zones_100.png',
    //   visible: view,
    // },
  ]

  const layers = LayersApi(bitmaps)

  return layers
}

export default bitMapLayers
